module.exports = __webpack_public_path__ + "static/media/BloggerStop.40f59405.png";